import React from 'react';
import BottomSheet from './BottomSheet';
import { Plane } from 'lucide-react';

const MobileFilterSheet = ({
  isOpen,
  onClose,
  selectedStops,
  setSelectedStops,
  selectedAirlines,
  setSelectedAirlines,
  priceRange,
  setPriceRange,
  stopCounts,
  uniqueAirlines,
  airlineLogos = {}
}) => {
  const toggleStop = (stopId) => {
    if (selectedStops.includes(stopId)) {
      setSelectedStops(selectedStops.filter(s => s !== stopId));
    } else {
      setSelectedStops([...selectedStops, stopId]);
    }
  };

  const toggleAirline = (code) => {
    if (selectedAirlines.includes(code)) {
      setSelectedAirlines(selectedAirlines.filter(a => a !== code));
    } else {
      setSelectedAirlines([...selectedAirlines, code]);
    }
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="Filters">
      <div className="p-4 pb-8 space-y-6">
        {/* Stops */}
        <div>
          <p className="text-sm font-bold text-gray-700 mb-3">Stops</p>
          <div className="flex gap-2">
            {[
              { id: 'nonStop', label: 'Direct', count: stopCounts.nonStop },
              { id: '1stop', label: '1 Stop', count: stopCounts.oneStop },
              { id: '2stop', label: '2+ Stops', count: stopCounts.twoPlus },
            ].map((s) => (
              <button
                key={s.id}
                onClick={() => toggleStop(s.id)}
                className={`flex-1 py-3 rounded-xl text-center text-xs font-semibold transition-all ${
                  selectedStops.includes(s.id)
                    ? 'bg-[#659A9B] text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <span className="block">{s.label}</span>
                <span className="block text-[10px] font-normal mt-0.5 opacity-70">{s.count}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Price Range */}
        <div>
          <p className="text-sm font-bold text-gray-700 mb-3">Price Range</p>
          <div className="bg-gray-50 rounded-xl p-4">
            <input
              type="range"
              min="5000"
              max="70000"
              step="1000"
              value={priceRange[1]}
              onChange={(e) => setPriceRange([priceRange[0], Number(e.target.value)])}
              className="w-full accent-[#659A9B]"
            />
            <div className="flex justify-between text-sm mt-2">
              <span className="text-gray-500">₹{priceRange[0].toLocaleString()}</span>
              <span className="font-bold text-[#1B375B]">₹{priceRange[1].toLocaleString()}</span>
            </div>
          </div>
        </div>

        {/* Airlines */}
        <div>
          <p className="text-sm font-bold text-gray-700 mb-3">Airlines</p>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {uniqueAirlines.map((a) => {
              const isSelected = selectedAirlines.includes(a.code);
              return (
                <button
                  key={a.code}
                  onClick={() => toggleAirline(a.code)}
                  className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl text-left transition-all ${
                    isSelected ? 'bg-[#659A9B]/10 ring-2 ring-[#659A9B]/40' : 'bg-gray-50 hover:bg-gray-100'
                  }`}
                >
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    {airlineLogos[a.code]?.square ? (
                      <img src={airlineLogos[a.code].square} alt={a.name} className="w-full h-full object-contain" />
                    ) : (
                      <Plane className="w-4 h-4 text-[#659A9B]" />
                    )}
                  </div>
                  <span className={`text-sm flex-1 ${isSelected ? 'font-semibold text-[#1B375B]' : 'text-gray-700'}`}>
                    {a.name}
                  </span>
                  {isSelected && (
                    <div className="w-5 h-5 rounded-full bg-[#659A9B] flex items-center justify-center">
                      <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Apply Button */}
        <button
          onClick={onClose}
          className="w-full py-4 bg-[#1B375B] text-white rounded-xl font-bold hover:bg-[#659A9B] transition-all shadow-lg"
        >
          Apply Filters
          {(selectedStops.length + selectedAirlines.length) > 0 && (
            <span className="ml-2 px-2 py-0.5 bg-white/20 rounded-full text-xs">
              {selectedStops.length + selectedAirlines.length}
            </span>
          )}
        </button>
      </div>
    </BottomSheet>
  );
};

export default MobileFilterSheet;
